import {uniqBy} from 'ramda';

import {type LastActiveBusinessCaseResponseBody} from '@dms/api/sales';

import {type Nullish} from 'shared/web';

type OfferingBusinessCase = {businessCaseId: string; businessCasePublicId: string | null};

const NOT_OPEN_STATES = ['CLOSED', 'UNSUCCESSFUL'];

/**
 * Other open Business Cases that already offer a stock vehicle, as their deal vehicle or as an
 * alternative. The backend refuses such a vehicle as a source (OFFERED_ELSEWHERE). The deal-vehicle
 * lookup lists only Business Cases the user may read, so an empty result is no guarantee.
 */
export const getOfferedElsewhere = (
  businessCaseId: string,
  lastSellingBusinessCase: LastActiveBusinessCaseResponseBody | Nullish,
  alternativeOfferings: OfferingBusinessCase[]
): OfferingBusinessCase[] => {
  const dealVehicleOffering =
    lastSellingBusinessCase &&
    !NOT_OPEN_STATES.includes(lastSellingBusinessCase.businessCaseState ?? '')
      ? [
          {
            businessCaseId: lastSellingBusinessCase.id,
            businessCasePublicId: lastSellingBusinessCase.code,
          },
        ]
      : [];

  return uniqBy(
    (offering) => offering.businessCaseId,
    [...dealVehicleOffering, ...alternativeOfferings]
  ).filter((offering) => offering.businessCaseId !== businessCaseId);
};
